<template>
  <div class="py-32 flex items-center justify-center">
    <div class="bg-white rounded-xl p-32 py-20 mx-2">
      <h2 class="login__title">LOGIN</h2>
      <button class="common-btn" @click="login" :disabled="isLoading">LOG IN WITH OKTA</button>
      <div class="common-error-message mt-2" v-if="error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import {useAuth} from '@okta/okta-vue';

export default {
  name: 'Login',
  setup() {
    const auth = useAuth();
    const isLoading = ref(false);
    const error = ref(null);
    const login = async () => {
      isLoading.value = true;
      try {
        await auth.signInWithRedirect();
      } catch (e) {
        error.value = 'Unable to start JA I.D. login. Please try again.';
        isLoading.value = false;
      }
    };
    return {login, isLoading, error};
  }
};
</script>

<style lang="stylus" scoped>
@import "../Styles/login.styl";
</style>
